import { faksApiInstance } from 'api';
import { router } from 'routes';
import { useAuthStore } from 'stores/authStore';
import { useStrongAuthStore } from 'stores/strongAuthStore';
import { isStrongAuthenticationError } from 'types/api/strong_authentication';

// To prevent dependency cycles, interceptors init must be setup outside of api files and auth store

export const initApi = () => {
  faksApiInstance.client.interceptors.request.use((config) => {
    const auth = useAuthStore.getState();
    return {
      ...config,
      headers: {
        'X-WebAppVersion': import.meta.env.RELEASE_ID,
        Authorization: auth?.userToken || null,
        ...(auth?.currentRoleId ? { 'X-CurrentRoleId': auth.currentRoleId } : {}),
        ...(auth?.trueUserId !== auth?.currentUserId
          ? { 'impersonated-user-id': auth?.currentUserId }
          : {}),
        ...config.headers,
      },
    };
  });

  faksApiInstance.client.interceptors.response.use(undefined, (error) => {
    if (
      error?.response?.status === 403 &&
      error?.response.data.error === 'access_denied_role_not_found'
    ) {
      useAuthStore.getState().setCurrentRoleId(null);
      window.location.href = '/';
    }
    if (error?.response?.status === 403 && isStrongAuthenticationError(error?.response?.data)) {
      return useStrongAuthStore
        .getState()
        .requireStrongAuth(error.response.data.error_details.kind)
        .then(
          () => faksApiInstance.client.request(error.config),
          () => Promise.reject(error)
        );
    }
    if (error?.response?.status === 401) {
      useAuthStore.getState().signOut({ signInToken: router.state.location.search.sign_in_token });
    }
    return Promise.reject(error);
  });
};
